import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-viewer-poi-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './poi.component.html',
    styleUrls: ['./poi.component.scss'],
    standalone: false
})
export class PoiComponent {
  /**
   * Constructor
   *
   * @param slideViewerFacade
   * @param menuSharedFacade
   */
  constructor(public slideViewerFacade: SlideViewerFacade,
              public menuSharedFacade: MenuSharedFacade) {
  }
}
